import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ProductivityApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.PRODUCTIVITY);
  }

  getPicking(params) {
    return this.httpClient.get(`${this.getResourceUrl()}picking/`, { params });
  }

  getShipmentCompletion(params) {
    return this.httpClient.get(`${this.getResourceUrl()}shipment-completion/`, {
      params,
    });
  }
}

export default new ProductivityApi();
